// http/index.js
import axios from "axios";
import { ElLoading, ElMessage } from "element-plus";
import { store } from "@/store";
import router from "../router";
let codeFlag = true;
const uuid = localStorage.getItem("uuid");
const preset = {
  service: "BASE_URL"
};
//创建axios的一个实例
var instance = axios.create({
  baseURL: process.env.VUE_APP_SAFE_URL, //接口统一域名
  timeout: 60000, //设置超时
  headers: {
    "Content-Type": "application/json;charset=UTF-8;",
    Accept: "*/*"
  },
  data: {
    ...(localStorage.getItem("token")
      ? { companyId: localStorage.getItem("currentCompany") }
      : {})
  }
});

async function responseInterceptor(response, resolve, reject) {
  const { code, status, repCode, exceptionClazz = "" } = response.data;
  const { data, url, service = preset.service } = response.config;
  if (repCode) {
    resolve(response.data);
  } else if (code === "00000" || status === 0) {
    resolve(response.data);
  } else if (code === "B0001" && exceptionClazz) {
    ElMessage.error(
      "系统正在对平台数据进行维护，请稍后再试。如有问题，请进入【客服与帮助中心】联系在线客服"
    );
    reject(response);
  } else if (code === "D9998") {
    if (codeFlag) {
      codeFlag = false;
      ElMessage.error(
        "请重新登录"
      );
      store.state.auth.token = null;
      store.state.auth.refreshToken = null;
      localStorage.clear();
      router.replace("/login");
      reject(response);
    }
  } else if (code === "B0301" || status === "B0301") {
    if (codeFlag) {
      codeFlag = false;
      ElMessage.error(
        "请重新登录"
      );
      // store.state.auth.token = null;
      // store.state.auth.refreshToken = null;
      localStorage.clear();
      store.commit("auth/clear");
      router.replace("/login");
      reject(response);
    }
    // let storageRequest = {};
    // storageRequest.url = url;
    // storageRequest.data =
    //   response.config.data && JSON.parse(response.config.data);

    // if (codeFlag) {
      // let refresh = await instance.post("/login/refreshAccessToken", {
      //   refreshToken: localStorage.getItem("refreshToken"),
      //   clientId: "10006"
      // });
      // store.commit("auth/setToken", refresh.data.access_token);
      // store.commit("auth/setRefreshToken", refresh.data.refresh_token);

    //   let storageRequestRes = instance.post(
    //     storageRequest.url,
    //     storageRequest.data
    //   );
    //   resolve(storageRequestRes);
    // }
  } else if (code && code.includes("A")) {
    ElMessage.warning(response.data.message);
    reject(response);
  } else if (code && code.includes("B")) {
    ElMessage.warning(`操作失败，原因：${response.data.message}`);
    reject(response);
  } else {
    if (!(code || status)) {
      resolve(response.data);
      return;
    }
    ElMessage.error(
      service === "BASE_URL"
        ? "啊哦，平台遇到了一些问题"
        : "啊哦，学堂遇到了一些问题"
    );
    reject(response);
  }
}

//请求拦截器
instance.interceptors.request.use(
  (config) => {
    if (config.url === "/login/signIn") {
      codeFlag = true;
    }
    config.header &&
      config.header.AppSecretKey &&
      (config.headers.AppSecretKey = config.header.AppSecretKey);

    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    const token = localStorage.getItem("token");
    token && (config.headers.Authorization = token);
    // header里也增加企业ID
    const companyId = config.data?.companyId || localStorage.getItem("currentCompany");
    companyId && (config.headers.CompanyId =  companyId);

    if (uuid && !config.url.includes("/WebApp") && !config.pass_proxy) {
      config.headers.deviceId = uuid;
    }

    config.url.includes("/WebApp") &&
      (config.baseURL = process.env.VUE_APP_SAFE_PHP_URL);

    config.pass_proxy && (config.baseURL = "/host");

    //若请求方式为post，则将data参数转为JSON字符串
    if (
      (config.method === "post" || config.method === "put"|| config.method === "delete") &&
      !(config.data instanceof FormData)
    ) {
      config.data = {
        ...(localStorage.getItem("token")
          ? { companyId: localStorage.getItem("currentCompany") }
          : {}),
        ...config.data
      };
      config.data = JSON.stringify(config.data);
    }
    return config;
  },
  (error) =>
    // 对请求错误做些什么
    Promise.reject(error)
);
//响应拦截器
instance.interceptors.response.use(
  async (response) => {
    return new Promise(async (resolve, reject) => {
      // hideLoading();
      //响应成功
      if (response.config.baseURL === "/host") {
        resolve(response.data);
      } else {
        responseInterceptor(response, resolve, reject);
      }
    });
  },
  (error) => {
    return new Promise(async (resolve, reject) => {
      const { service = preset.service } = error.config;
      ElMessage.error(
        service === "BASE_URL"
          ? "啊哦，平台遇到了一些问题"
          : "啊哦，学堂遇到了一些问题"
      );
      reject(error);
    });
  }
);

export default instance;
